<div>
  @switch (unauthorizedType) {
    @case ("1") {
      <app-redirect-pending-approval
        [supportEmail]="supportTeamMail"
        mainMessage="Sorry, you do not have access to the tool."
        subMessage="Please contact us at"
      ></app-redirect-pending-approval>
    }
    @case ("2") {
      <app-redirect-pending-approval
        [supportEmail]="supportTeamMail"
        mainMessage="Your access request has not been approved yet."
        subMessage="Please try again later.. If the issue persists email us at"
      ></app-redirect-pending-approval>
    }
    @case ("3") {
      <app-redirect-pending-approval
        [supportEmail]="supportTeamMail"
        mainMessage="Your access request has been rejected."
        subMessage="For further assistance email us at"
      ></app-redirect-pending-approval>
    }
    @case ("4") {
      <app-redirect-pending-approval
        [supportEmail]="supportTeamMail"
        mainMessage="Your access has been revoked."
        subMessage="For further assistance email us at"
      ></app-redirect-pending-approval>
    }
    @default {
      <app-redirect-pending-approval
        [supportEmail]="supportTeamMail"
        mainMessage="You are not authorized to access this page."
        subMessage="For further assistance email us at"
      ></app-redirect-pending-approval>
    }
  }
</div>
